/**
 * Shared layout for "HEY HO, LET'S GO!" email-entry screens.
 * Used by /validate-email (pages/EmailValidation) and /new-customer (pages/NewCustomer)
 * so header, headline, subtitle, card area, and footer are consistent.
 */
import React, { ReactNode } from 'react';
import { PageShell } from './layout/PageShell';
import '../pages/EmailValidation.css';

const DEFAULT_HEADLINE = "HEY HO, LET'S GO!";
const DEFAULT_INSTRUCTION = 'Enter your email address to begin.';

export interface EmailEntryLayoutProps {
  /** Optional content between headline and card (e.g. gift card banner) */
  topContent?: ReactNode;
  /** Main content inside the white card */
  children: ReactNode;
  /** Optional class name for the root container */
  className?: string;
  /** Optional headline above the card (default: "HEY HO, LET'S GO!") */
  headline?: string;
  /** Optional instruction text below headline (default: "Enter your email address to begin.") */
  instruction?: string;
}

const EmailEntryLayout: React.FC<EmailEntryLayoutProps> = ({
  topContent,
  children,
  className = '',
  headline = DEFAULT_HEADLINE,
  instruction = DEFAULT_INSTRUCTION
}) => {
  return (
    <PageShell className={`email-validation-page ${className}`.trim()}>
      <h1 className="ev-display-headline ev-animate-in ev-headline-above">{headline}</h1>
      <p className="ev-display-subtitle ev-animate-in ev-instruction-above">{instruction}</p>
      {topContent && <div className="ev-animate-in">{topContent}</div>}
      <div className="ev-shell-card ev-card-form ev-animate-in">{children}</div>
    </PageShell>
  );
};

export default EmailEntryLayout;
